import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogActions } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

export interface ChangeNameDialogData {
    name: string;
    isTourEdit: boolean;
    isCheckout: boolean;
}

/** `undefined` = weggedrückt. Objekt = weitermachen; `name` darf `''` sein. */
export interface ChangeNameDialogResult {
    name: string;
}

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-change-name-dialog',
    templateUrl: './change-name-dialog.component.html',
    styleUrls: ['./change-name-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        MatFormField,
        MatLabel,
        MatInput,
        ReactiveFormsModule,
        FormsModule,
        MatDialogActions,
        MatButton,
        TranslateModule,
    ],
})
export class ChangeNameDialogComponent {
    name: string = '';
    originalName: string = '';
    isTourEdit: boolean = false;
    isCheckout: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: ChangeNameDialogData,
        private dialogRef: MatDialogRef<
            ChangeNameDialogComponent,
            ChangeNameDialogResult
        >
    ) {
        this.name = data.name;
        this.originalName = data.name;
        this.isTourEdit = data.isTourEdit;
        this.isCheckout = data.isCheckout;
    }

    /** Kein Abbruch: weiter mit dem unveränderten Namen, beim Anlegen also ohne. */
    skip() {
        this.dialogRef.close({ name: this.originalName });
    }

    saveAndClose() {
        this.dialogRef.close({ name: this.name });
    }

    isEditTourConfirmButtonDisabled(): boolean {
        return this.name === this.originalName;
    }
}
